/**
 * External dependencies.
 */
import { assign } from 'lodash';

/**
 * Internal dependencies.
 */
import { getTextStyle, updateBlock, addStyleTag } from '../../extensions/custom-styles';

function styling( props, selector = false, attributes = false ) {
	const { blockAdvanceOptions } = attributes ? attributes : props.attributes;
	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId }`;
	css += getTextStyle( blockAdvanceOptions, selector );

	return css;
}

const updateBlockStyle = ( data, props ) => {
	const attrs = assign( props.attributes, data );
	const css = styling( props, false, attrs );

	updateBlock( data, css, props );

	// Admin.
	const adminCss = styling( props, `#block-${ props.clientId }  > *` );
	addStyleTag( props, adminCss, `gutenify-block-${ props.clientId }-main`, true );
};

export { updateBlockStyle };
export default styling;

